import { gql } from "@apollo/client";

export interface VehicleType {
  id: number;
  vehicleModelId: number;
  warehouseId: number;
  vehicleNumber: string;
  licensePlate: string;
  maxWeightLbs?: number;
  maxVolumeFt3?: number;
  lengthFt?: number;
  widthFt?: number;
  heightFt?: number;
  fuelType: number;
  vehiclePhotos?: string[];
  status: number;
  notes?: string;
  vehicleModelName?: string;
  warehouseName?: string;
  fuelTypeName?: string;
  vehicleTypeId?: number;
  vehicleTypeName?: string;
}

export interface VehicleTypeDetail {
  id: number;
  vehicleModelId: number;
  warehouseId: number;
  vehicleNumber: string;
  licensePlate: string;
  maxWeightLbs?: number;
  maxVolumeFt3?: number;
  lengthFt?: number;
  widthFt?: number;
  heightFt?: number;
  fuelType: number;
  vehiclePhotos?: string[];
  status: number;
  notes?: string;
  vehiclePhotoUrls?: string[];
  vehicleModelName?: string;
  warehouseName?: string;
  fuelTypeName?: string;
  vehicleTypeId?: number;
  vehicleTypeName?: string;
}

export const VEHICLE_TYPE_DETAIL_FIELDS = gql`
  fragment VehicleTypeDetailFields on VehicleType {
    id
    vehicleModelId
    warehouseId
    vehicleNumber
    licensePlate
    maxWeightLbs
    maxVolumeFt3
    lengthFt
    widthFt
    heightFt
    fuelType
    vehicleModelName
    warehouseName
    fuelTypeName
    vehiclePhotos
    status
    notes
    vehiclePhotoUrls
    vehicleTypeId
    vehicleTypeName
  }
`;

export const VEHICLE_TYPE_FIELDS = gql`
  fragment VehicleTypeFields on VehicleType {
    id
    vehicleModelId
    warehouseId
    vehicleNumber
    licensePlate
    maxWeightLbs
    maxVolumeFt3
    lengthFt
    widthFt
    heightFt
    fuelType
    vehicleModelName
    warehouseName
    fuelTypeName
    vehiclePhotos
    status
    notes
    vehicleTypeId
    vehicleTypeName
  }
`;